import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ImportCustomerRetailPricesMutationVariables = Types.Exact<{
  input: Types.ImportCustomerRetailPricesInput;
}>;


export type ImportCustomerRetailPricesMutation = { __typename?: 'Mutation', importCustomerRetailPrices: { __typename?: 'ImportCustomerRetailPricesPayload', rows: Array<{ __typename?: 'CustomerRetailPriceRowResult', rowIndex: number, itemId?: string | null, status: Types.CustomerRetailPriceRowStatus, message?: string | null }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const ImportCustomerRetailPricesDocument = new TypedDocumentString(`
    mutation ImportCustomerRetailPrices($input: ImportCustomerRetailPricesInput!) {
  importCustomerRetailPrices(input: $input) {
    rows {
      rowIndex
      itemId
      status
      message
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    ImportCustomerRetailPrices: build.mutation<ImportCustomerRetailPricesMutation, ImportCustomerRetailPricesMutationVariables>({
      query: (variables) => ({ document: ImportCustomerRetailPricesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useImportCustomerRetailPricesMutation } = injectedRtkApi;
